import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Grid } from '@mui/material';
import { nTrialsState } from 'features/optimization/state/appConfigAtoms';
import { CustomNumberField } from 'shared/ui/CustomNumberField';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const NtrialsSelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [appNtrials, setAppNtrials] = useRecoilState(nTrialsState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value > 0 && value <= 1024) {
      setAppNtrials(value); // Set only natural numbers within the range
    } else {
      setAppNtrials(1); // Default to 1 if the input is invalid or exceeds 1024
    }
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <CustomNumberField
            required
            label="num. of trials"
            type="number"
            value={appNtrials}
            onChange={handleChange}
            inputProps={{ min: 1, max: 100, step: 1 }} // Set natural numbers from 1 to 1024
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#1e1e1e',
              },
              width: '100px',
              margin: '8px'
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
